import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SocialType } from "../../../provider/home/HomeContextProvider";
import { SearchBranchList } from "../../../model/branch/BranchListModel";
import { BranchInfoGuest } from "../../../model/home_guest_user/GuestBranchInfoModel";

interface HomeGuestUserInterface {
  branchDetail?: BranchInfoGuest | null;
  contactList?: Array<string> | undefined;
  socialLinks?: Array<SocialType> | undefined;
  switchBranchDetail?: SearchBranchList;
}

const initialState: HomeGuestUserInterface = {
  branchDetail: null,
  contactList: undefined,
  socialLinks: undefined,
  switchBranchDetail: undefined,
};

const homeGuestSlice = createSlice({
  name: "homeguestuser",
  initialState,
  reducers: {
    setGuestBranchInfo: (
      state,
      action: PayloadAction<HomeGuestUserInterface>
    ) => {
      return { ...state, ...action.payload };
    },
    applyGuestBranchSwitch: (
      state,
      action: PayloadAction<HomeGuestUserInterface>
    ) => {
      state.switchBranchDetail = action.payload.switchBranchDetail;
    },
  },
});

export const { setGuestBranchInfo, applyGuestBranchSwitch } =
  homeGuestSlice.actions;
export default homeGuestSlice.reducer;
